import './dev.scss';
import data from './strat02.json';
import { stickyHeader } from './stickyHeader';
import { analytics } from './analytics';
import { polyfills } from './forEachPolyfill';

if (process.env.NODE_ENV !== 'production') {
	// require('./template.html');
	console.log('Looks like we are in development mode!');
}

polyfills();

function app(strategies){
	const goals = ["Improve attendance and completion", "Improve learning and development", "Redefine purpose for students", "Redefine purpose for society"],
		container = document.getElementById("result-container"),
		goalBtns = document.querySelectorAll(".goal__button"),
		clearGoalsBtn = document.querySelector(".finder--clear-goals"),
		goalInfoBtn = document.getElementById("info__goals"),
		filterInfoBtn = document.getElementById("info__filters"),
		interstitial = document.querySelector(".interstitial__card"),
		filterBtns = document.querySelectorAll(".filter--dropdown"),
		activeFilters = { "goals": goals, "country": [], "student-age": [], "lever":[] };
	let updateNeeded;

	// check for mobile view
	function mobile(){
		let mql = window.matchMedia('(max-width:781px)'); 
		
		return mql.matches;
	}

	// add event listeners for interstitial 
	function interstitialFunctionality(){
		let card = interstitial.querySelector("div"),
			close = card.querySelector(".interstitial__close");

		function disableScroll(){
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop,
				scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;


			window.onscroll = function() {
				window.scrollTo(scrollLeft, scrollTop);
			}
		}

		function enableScroll(){
			window.onscroll = function(){};
		}

		mobile() ? disableScroll() : "";

		interstitial.addEventListener("click", () => {
			interstitial.classList.remove("interstitial__open");
			
			mobile() ? enableScroll() : "";
		})

		card.addEventListener("click", e => {
			e.stopPropagation();
		})

		close.addEventListener("click", () => {
			interstitial.classList.remove("interstitial__open");
			
			mobile() ? enableScroll() : "";
		})
	}

	// populate the interstitial with the expanded view of the selected strategy
	function buildExpanded(strategy){
		const template = document.getElementById("filter--card__expanded").cloneNode(["deep"]);
		let cardTitle = template.querySelector("h2"),
			cardDescription = template.querySelector(".card--description"),
			cardTags = template.querySelectorAll(".card--tags"),
			cardCTALink = template.querySelector("a.card--cta"),
			cardCTA = template.querySelector(".card--cta__label");

		interstitial.innerHTML = "";
		template.classList = "";

		for (let key in strategy) {
			cardTitle.innerText = `${strategy["strategy"]}`;
			cardDescription.innerText = strategy["description"];

			if (strategy["call-to-action"] == null) {
				cardCTA.style.display = "none";
			} else {
				cardCTA.style = "";
				cardCTA.innerText = `${strategy["call-to-action"]}`;
			}

			cardCTALink.setAttribute("href", strategy["url"]);

			cardTags.forEach(y => {
				let fieldName = y.id.split("tags__")[1],
					fieldEntry = y.querySelector(".card--tags__info");

				if (Array.isArray(strategy[fieldName])) {
					if (fieldName != "goals") {
						fieldEntry.querySelector(`span.tag-response__${fieldName}`).innerText = strategy[fieldName].join(", ")
					} else {
						let response = strategy[fieldName].map(item => {
								let i = goals.indexOf(item);

								template.classList.add(`goal_0${i +1}`);
								return `<span class="tag-response__goals goal_0${i + 1}">${item}</span>`;
							});

						fieldEntry.innerHTML = "";

						response.forEach(x => {
							fieldEntry.innerHTML += x;
						})
					}
				} else if (fieldName == "organization") {
					let organizationContainer = fieldEntry.querySelector(".org-type-container");

					fieldEntry.querySelector(`span.tag-response__${fieldName}-name`).innerText = strategy[fieldName];
					organizationContainer.innerHTML = "";

					if (Array.isArray(strategy["organization-type"])) {
						let response = strategy["organization-type"].map(item => {
							return `<span class="tag-response__organization-type">${item}</span>`;
						});

						response.forEach(x => {
							organizationContainer.innerHTML += x;
						})

					} else {
						organizationContainer.innerHTML = `<span class="tag-response__organization-type">${strategy["organization-type"]}</span>`;
					}
				} else {
					fieldEntry.querySelector(`span.tag-response__${fieldName}`).innerText = strategy[fieldName];
				}
			});
		}

		// track analytics
		cardCTALink.addEventListener("click", e => {
			let label = strategy["strategy"].toLowerCase().replace(/\s|\-/gi, "_").replace("’", "");

			analytics("read_more", label);
		});

		interstitial.appendChild(template);
		interstitial.classList.add("interstitial__open");
		interstitialFunctionality();
	}

	// build preview cards for selection
	function buildCards(data) {
		let desktopTotal = document.getElementById("title--totals"),
			mobileTotal = document.getElementById("mobile-totals");

		container.innerHTML = "";

		// catch the cases where a user has drilled down to zero results
		if (data.length == 0) {
			let message = document.createElement("div"),
				countries = document.querySelectorAll(".select-items > .option__hidden"),
				reset = document.createElement("button");

			message.setAttribute("class", "cue--message");
			message.innerText = "There are no strategies matching your criteria.";
			reset.setAttribute("class", "cue--reset");
			reset.innerText = "Clear filter selections";

			countries.forEach(country => {
				country.classList.remove("option__hidden");
			})

			reset.addEventListener("click", () => {
				let filterSelection = document.querySelectorAll(".selected, input:checked"),
					filterPill = document.querySelectorAll("#results--active-filters .filter--pill");

				filterSelection.forEach(x => {
					x.classList.contains("selected") ? x.classList.remove("selected") : "";
					x.checked == true ? x.checked = false : "";

					activeFilters["country"] = [];
					activeFilters["student-age"] = [];
					activeFilters["tech-level"] = null;
					activeFilters["lever"] = [];
 				});

 				filterPill.forEach(pill => { pill.remove() });

 				filterCards(strategies["strategies"], goals);
 				document.querySelector("#js--mobile-master-controls .filter__clear").classList.remove("activated");
 				document.getElementById("filter__mobile-totals").classList.contains("filter__selected") ? document.getElementById("filter__mobile-totals").classList.remove("filter__selected") : "";
			})

			message.appendChild(reset);
			container.appendChild(message);
		}

		// if there is data to show, build each of the cards
		data.forEach((x,i) => {
			const template = document.getElementById("preview__template").cloneNode(["deep"]);
			let cardTitle = template.querySelector("h2"),
				cardTags = template.querySelectorAll(".card--tags");
				
				cardTitle.innerText = `${x["strategy"]}`;
				template.id = `strategy_${i}`;

			for (let key in x) {
				cardTags.forEach(y => {
					let fieldName = y.id.split("tags__")[1],
						fieldEntry = y.querySelector(".card--tags__info");

					Array.isArray(x[fieldName]) ? fieldEntry.querySelector(`span.tag-response__${fieldName}`).innerText = x[fieldName].join(", ")
 					: fieldEntry.querySelector(`span.tag-response__${fieldName}`).innerText = x[fieldName];
				});

				if (key == "goals") {
					x[key].forEach(y => {
						if (y == goals[0]) {
							template.classList.add("goal_01");
						} else if (y == goals[1]) {
							template.classList.add("goal_02");
						} else if (y == goals[2]) {
							template.classList.add("goal_03");
						} else if (y == goals[3]) {
							template.classList.add("goal_04");
						}
					});
				};
			}

			template.addEventListener("click", () => {
				let label = x["strategy"].toLowerCase().replace(/\s|\-/gi, "_").replace("’", "");

				analytics("card_click", label);
				buildExpanded(x);
			})

			container.appendChild(template);
		});

		// update displayed totals
		desktopTotal.innerText = data.length;
		mobileTotal.innerText = data.length;
	}

	// filter the data to match selection and pass it to build cards
	function filterCards(data) {
		let match;

		function filterCardsByGoal(goalsToFilter){
			let title = document.getElementById("results__title");

			if (goalsToFilter.length < 4) {
				match = data.filter(item => { 
					for (let i = 0; i < goalsToFilter.length; i++){
						if (item["goals"].includes(goalsToFilter[i])) {
							return item;
						}
					}	
				});
			} else {
				match = data;
			}

			activeFilters.goals = goalsToFilter;	

			goalsToFilter.length < 4 ? title.innerText = goalsToFilter.join(", ") : title.innerText = "Showing all strategies";
			
			return match;
		};

		function filterCardsByOther(updatedList){
			let mappy = updatedList;

			if (activeFilters["country"].length > 0) {
				mappy = updatedList.filter(item => {
					return activeFilters["country"].some(country => {
						if (Array.isArray(item["country"])) {
							return item["country"].indexOf(country) !== -1; 
						} else if (item["country"] == "International") {
							return item;
						} else {
							return item["country"] == country;
						}
					})
				});
			}

			if (activeFilters["student-age"].length > 0) {
				// update age
				mappy = mappy.filter(item => {
					return activeFilters["student-age"].some(age => { return item["student-age"].indexOf(age) !== -1; })
				});

			}
			
			if (activeFilters["tech-level"] != null) {
				// update tech level
				mappy = mappy.filter(item => { return activeFilters["tech-level"] == item["tech-level"]; })
			}

			if (activeFilters["lever"].length > 0){
				// update lever
				mappy = mappy.filter(item => {
					return activeFilters["lever"].some(lever => { return item["lever"].indexOf(lever) !== -1; })
				});
			}
			
			return match = mappy;
		}

		filterCardsByGoal(activeFilters.goals);
		filterCardsByOther(match);
		updateFilterOptions(match);

		console.log(activeFilters);


		// animate the cards changing, then chain sequence via settimeout
		container.classList.add("empty__animation");
		setTimeout(() => { buildCards(match)}, 300);
		setTimeout(() => {
			let toppy = document.getElementById("cue-strategy-finder").getBoundingClientRect(),
				mobilescrol = document.getElementById("finder--container-for-mobile"),
				mobileToppy = document.getElementById("finder--container-for-mobile").getBoundingClientRect();

			mobile()? "" : window.scroll(0, (window.pageYOffset + toppy.top) - 120);
			container.classList.remove("empty__animation");
		}, 450);		
	}

	// update the filter list options to only show what's still available
	function updateFilterOptions(data){
		let countries = ["Argentina", "Australia", "Botswana", "Brazil", "Canada", "Colombia", "England", "Ethiopia", "Ghana", "Guatemala", "Honduras", "Hungary", "India", "Jamaica", "Netherlands", "Northern Ireland", "Portugal", "Romania", "South Africa", "Spain", "Uganda", "United Kingdom", "United States", "Wales", "Zimbabwe"],
			ageGroup = ["Early Childhood", "Primary", "Lower Secondary", "Upper Secondary"],
			techLevel = ["No tech", "Low tech", "High tech"],
			levers = ["Providing information", "Building relationships", "Shifting mindsets", "Building skills", "Providing resources", "Designing"],
			remainingOptions, exists, option;

		function checkForMatch(check, elem){
			if (check == false) {
				if (elem.classList.contains("selected")) {
					return;
				} else {
					elem.classList.add("option__hidden");
				}
			} else {
				elem.classList.contains("option__hidden") ? elem.classList.remove("option__hidden") : "";
			}
		}

		techLevel.forEach(tech => {
			exists = false,
			option = document.querySelector(`input[value="${tech.toLowerCase().replace(" ", "-")}"`).parentElement;
			
			for (let i = 0; i < data.length; i++) {
				if (data[i]["tech-level"] == tech) {
					exists = true;
					break;
				}
			};

			checkForMatch(exists, option);
		});

		ageGroup.forEach(age => {
			exists = false,
			option = document.querySelector(`input[value="${age.toLowerCase().replace(" ", "-")}"`).parentElement;

			for (let i = 0; i < data.length; i++) {
				if (data[i]["student-age"].includes(age)) {
					exists = true;
					break;
				}
			}

			checkForMatch(exists, option);
		});

		levers.forEach(lever => {
			exists = false,
			option = document.querySelector(`input[value="${lever.toLowerCase().replace(" ", "-")}"`).parentElement;

			for (let i = 0; i < data.length; i++) {
				if (data[i]["lever"].includes(lever)) {
					exists = true;
					break;
				}
			}

			checkForMatch(exists, option);
		});

		countries.forEach(country => {
			exists = false,
			option = document.querySelector(`.select-items div[data-val="${country}"]`);

			for (let i = 0; i < data.length; i++) {
				if (data[i]["country"].includes(country)) {
					exists = true;
					break;
				}
			}

			checkForMatch(exists, option);
		});
	}

	// for global updating, check every subfilter
	function checkAllSubfilters(){
		let options = document.querySelectorAll(".filter__block"),
			updateNeeded = undefined;

		options.forEach(menu => {
			if (menu.id == "countries") {
				let selected = menu.querySelectorAll(".selected"),
					values = [];

				if (selected.length > 0) {
					selected.forEach(x => { values.push(x.innerText) });
					activeFilters["country"] = values;
					updateNeeded = true;
				} else if (selected.length == 0 && activeFilters["country"].length > 0) {
					activeFilters["country"] = values;
					updateNeeded = true;
				} 
			} else if (menu.id == "tech-level") {
				let checked = menu.querySelector("input:checked"),
					param;

				if (checked !== null ) {
					param = checked.parentElement.querySelector(".filter-option__name").innerText;
					
					if (param !== activeFilters["tech-level"]) {
						activeFilters["tech-level"] = param;
						updateNeeded = true;
					}
				} else if (checked == null && activeFilters["tech-level"] !== null) {
					activeFilters["tech-level"] = null;
					updateNeeded = true;
				} else if (checked !== null && checked.parentElement.querySelector(".filter-option__name").innerText !== activeFilters["tech-level"]) {
					activeFilters["tech-level"] = checked.parentElement.querySelector(".filter-option__name").innerText;
					updateNeeded = true;
				} else {
					""
				}
			} else {
				let checked = menu.querySelectorAll("input:checked"),
				type = menu.id,
				values = [];

				if (checked.length > 0) {
					checked.forEach(val => {
						let param = val.parentElement.querySelector(".filter-option__name").innerText;

						!values.includes(param) ? values.push(param) : "";
					});

					activeFilters[type] = values;
					updateNeeded = true;
				} else if (activeFilters[type].length > 0 && checked.length == 0) {
					activeFilters[type] = values;
					updateNeeded = true;
				}
			}		
		})

		return updateNeeded;
	}

	// on desktop, add the filter as an available button
	function addToFilterList(filters, type){
		let container = document.getElementById("results--active-filters"),
			currentlyListed = container.querySelectorAll(".filter--pill");

		// Create the pill, add an event listener to the close button that allows user to 
		// update the interactive, and add the pill to the page
		function updateList(item){
			const template = document.getElementById("active-filter__template").cloneNode(["deep"]);
			let btn = template.querySelector(".pill__close");

			template.id = item.toLowerCase().replace(" ", "-");
			template.classList.add(type);
			template.querySelector(".pill__name").innerText = item;

			btn.addEventListener("click", () => {
				let pill = btn.parentElement,
					menu = document.getElementById(type);

				// update the active filters global variable and rebuild the cards
				if (type == "tech-level") {
					menu.querySelector("input:checked").checked = false;
					activeFilters[type] = null;
					filterCards(strategies["strategies"]);
				} else {
					// find the index of the item to remove in the global variable so we can delete it
					let toRemove = activeFilters[type].indexOf(item);
					activeFilters[type].splice(toRemove, 1);

					// find and remove the selection from its drop down
					if (type == "country") {
						let menu = document.getElementById("countries"),
							selections = menu.querySelectorAll(".selected");

						selections.forEach(selected => {
							if (selected.dataset.val == item) {
								selected.classList.remove("selected");
							}
						});	
					} else {
						let selections = menu.querySelectorAll("input:checked");

						selections.forEach(select => {
							if (select.value == item.toLowerCase().replace(" ", "-")) {
								select.checked = false;
							}
						})
					}

					// update the interactive
					filterCards(strategies["strategies"]);
				}

				// remove the pill from the page
				pill.remove();
			});

			container.appendChild(template);
		}

		// see if the item already exists as a pill, and if not, add it
		function checkIfListed(item) {
			if (currentlyListed.length > 0 ) {
				let exists = false;

				currentlyListed.forEach(x => {
					if (x.id == item.toLowerCase().replace(" ", "-")) {
					 	exists = true;
					}
				});

				!exists ? updateList(item) : "";
			} else {
				updateList(item);
			}
		}

		// check if the argument supplied is an array and loop accordingly
		if (Array.isArray(filters)){
			filters.forEach(filter => {
				checkIfListed(filter);
			});
		} else {
			checkIfListed(filters);
		}
	}

	// attach functionality to the buttons for goal filtering
	goalBtns.forEach((x,i) => {
		x.addEventListener("click", e => {
			let index = i,
				label = x.querySelector(`#${x.id} > span`).innerText.toLowerCase().replace(/\s/gi, "_");

			x.classList.toggle("goal__active");

			function updateList(){
				let selected = document.querySelectorAll(".goal__active"),
					filters = [];

				if (selected.length == 0) {
					activeFilters.goals = goals;
					filterCards(strategies["strategies"]);
					clearGoalsBtn.classList.contains("activated") ? clearGoalsBtn.classList.remove("activated") : "";
				} else if (selected.length == 4) {
					// selected.forEach(btn => { btn.classList.remove("goal__active")});
					activeFilters.goals = goals;
					filterCards(strategies["strategies"], goals);
					// clearGoalsBtn.classList.remove("activated");
				} else {	
					selected.forEach(y => {
					let indexToPass = y.id.split("js--goal_")[1];

						filters.push(goals[indexToPass]);
					});

					activeFilters.goals = filters;

					filterCards(strategies["strategies"], filters);
					clearGoalsBtn.classList.contains("activated") ?  "" : clearGoalsBtn.classList.add("activated");
				}	
			}

			analytics("side_nav", label);
			updateList();	
		});
	});

	// clear the goal selection
	clearGoalsBtn.addEventListener("click", () => {
		let activeBtns = document.querySelectorAll(".goal__active");

		activeBtns.forEach(btn => { btn.classList.remove("goal__active") });
		activeFilters["goals"] = goals;

		filterCards(strategies["strategies"]);
		clearGoalsBtn.classList.remove("activated");
	});

	// open the sub-filter lists on click
	filterBtns.forEach(x => {
		x.addEventListener("click", () => {
			let menu = x.parentElement.querySelector(".filter__block"),
				elem = document.querySelector(".filter__block.filter__open");

			if (elem !== null && elem != menu) {
				elem.classList.remove("filter__open");
				elem.parentElement.querySelector("button").classList.remove("open");
			}

			if (menu.classList.contains("filter__open")) {
				checkAllSubfilters() ? filterCards(strategies["strategies"]) : "";
				menu.classList.remove("filter__open");
				x.classList.remove("open");
			} else {
				x.classList.add("open");
				menu.classList.add("filter__open");
			}
		});
	});

	// interstitial for info on goals
	goalInfoBtn.addEventListener("click", () => {
		const template = document.getElementById("finder--info__goals").cloneNode(["deep"]);

		interstitial.innerHTML = "";

		interstitial.appendChild(template);
		interstitial.classList.add("interstitial__open");
		interstitialFunctionality();
	});

	// interstitial for info on filters
	filterInfoBtn.addEventListener("click", () => {
		const template = document.getElementById("finder--info__filters").cloneNode(["deep"]);

		interstitial.innerHTML = "";

		interstitial.appendChild(template);
		interstitial.classList.add("interstitial__open");
		interstitialFunctionality();
	});

	// student age dropdown
	function ageFilter(){
		let contains = document.getElementById("filter__student-age"),
			inputOptions = contains.querySelectorAll("input[type='checkbox']"),
			submit = contains.querySelector(".filter__send"),
			clear = contains.querySelector(".filter__clear"),
			masterClear = document.querySelector("#js--mobile-master-controls .filter__clear"),
			values = [];

		inputOptions.forEach(x => { 
			x.addEventListener("change", input => {
				let checked = contains.querySelectorAll("input:checked");

				checked.forEach(val => {
					let param = val.parentElement.querySelector(".filter-option__name").innerText;

					!values.includes(param) ? values.push(param) : "";
				});

				analytics("nav_click_studentage", x.value);
				clear.classList.add("activated");
				masterClear.classList.add("activated");
			});
		});

		clear.addEventListener("click", () => {
			// remove pills showing active filters
			let matches = document.querySelectorAll(".filter--pill.student-age");

			matches.forEach(match => { match.remove() });
			inputOptions.forEach(x => { x.checked = false });
			clear.classList.remove("activated");
			values = [];
		});

		submit.addEventListener("click", () => {
			activeFilters["student-age"] = values;
			filterCards(strategies["strategies"]);
			contains.querySelector(".filter__block").classList.remove("filter__open");
			contains.querySelector("button").classList.remove("open");
			addToFilterList(values, "student-age");
		});
	};

	// tech level dropdown
	function techFilter(){
		let contains = document.getElementById("filter__tech-level"),
			inputOptions = contains.querySelectorAll("input[type='radio']"),
			submit = contains.querySelector(".filter__send"),
			clear = contains.querySelector(".filter__clear"),
			masterClear = document.querySelector("#js--mobile-master-controls .filter__clear"),
			value;

		inputOptions.forEach(x => { 
			x.addEventListener("change", input => {
				let checked = contains.querySelector("input:checked");

				value = checked.parentElement.querySelector(".filter-option__name").innerText;

				analytics("nav_click_techlevel", x.value);
				clear.classList.add("activated");
				masterClear.classList.add("activated");
			});
		});

		clear.addEventListener("click", () => {
			let matches = document.querySelectorAll(".filter--pill.tech-level");

			matches.forEach(match => { match.remove() });
			inputOptions.forEach(x => { x.checked = false });
			clear.classList.remove("activated");
			value = null;
		});

		submit.addEventListener("click", () => {
			activeFilters["tech-level"] = value;
			filterCards(strategies["strategies"]);
			contains.querySelector(".filter__block").classList.remove("filter__open");
			contains.querySelector("button").classList.remove("open");
			addToFilterList(value, "tech-level");
		});
	};

	// levers for change dropdown
	function leverFilter(){
		let contains = document.getElementById("filter__lever"),
			inputOptions = contains.querySelectorAll("input[type='checkbox']"),
			submit = contains.querySelector(".filter__send"),
			clear = contains.querySelector(".filter__clear"),
			masterClear = document.querySelector("#js--mobile-master-controls .filter__clear"),
			values = [];

		inputOptions.forEach(x => { 
			x.addEventListener("change", input => {
				let checked = contains.querySelectorAll("input:checked");

				checked.forEach(val => {
					let param = val.parentElement.querySelector(".filter-option__name").innerText;

					!values.includes(param) ? values.push(param) : "";
				});

				analytics("nav_click_leversforchange", x.value);
				clear.classList.add("activated");
				masterClear.classList.add("activated");
			});
		});

		clear.addEventListener("click", () => {
			let matches = document.querySelectorAll(".filter--pill.lever");

			matches.forEach(match => { match.remove() });
			inputOptions.forEach(x => { x.checked = false });
			clear.classList.remove("activated");

			values = [];
		});

		submit.addEventListener("click", () => {
			activeFilters["lever"] = values;
			filterCards(strategies["strategies"]);
			contains.querySelector(".filter__block").classList.remove("filter__open");
			contains.querySelector("button").classList.remove("open");
			addToFilterList(values, "lever");
		});
	};

	// country dropdown and select menu
	function buildCountryDropdown(){
		let contains = document.getElementById("filter__country"),
			dropdown = contains.querySelector(".country__inner"),
			select = contains.querySelector("select"),
			clear = contains.querySelector(".filter__clear"),
			masterClear = document.querySelector("#js--mobile-master-controls .filter__clear"),
			submit = contains.querySelector(".filter__send"),
			values = [],
			holder, holder2;

		holder = document.createElement("div");
		holder.setAttribute("class", "select-items");
		holder.setAttribute("aria-hidden", true);

		for(let i = 0; i < select.length; i++){
			holder2 = document.createElement("div");
			holder2.innerHTML = select.options[i].innerHTML;
			holder2.setAttribute("tabIndex", 0);
			holder2.dataset.val = select.options[i].innerHTML;
			holder2.addEventListener("click", e => {
				let that = e.target,
					y, yl;

				that.blur();

				for (let j = 0; j < select.length; j++) {
					if (select.options[i].innerHTML == that.innerHTML) {
						select.selectedIndex = i;
						let label = that.dataset.val.toLowerCase().replace(/\s/gi, "_");
						
						analytics("nav_click_country", label);
						that.classList.contains("selected") ? that.classList.remove("selected") : that.classList.add("selected")
						break;
					}
				}

				if (contains.querySelectorAll(".selected").length > 0) {
					clear.classList.add("activated"); 
					masterClear.classList.add("activated");
				} else {
					clear.classList.remove("activated");
				}

				countryFilter();
			});

			// allow for submission via enter key
			holder2.addEventListener("keyup", e => {
				if(e.keyCode === 13) {
					e.preventDefault();
					e.target.click();
				}
			});

			// append the list 
			holder.appendChild(holder2);
		}

		dropdown.appendChild(holder);

		function countryFilter(){
			let selectedCountries = contains.querySelectorAll(".selected");

			selectedCountries.forEach(x => { 
				if(values.indexOf(x.innerText) == -1) { values.push(x.innerText) } 
			});
		}

		clear.addEventListener("click", () => {
			let selectedCountries = contains.querySelectorAll(".selected"),
				matches = document.querySelectorAll(".filter--pill.country");

			matches.forEach(match => { match.remove() });
			selectedCountries.forEach(x => { x.classList.contains("selected") ? x.classList.remove("selected") : ""; });
			clear.classList.remove("activated");
			values = [];
		});

		submit.addEventListener("click", () => {
			activeFilters["country"] = values;
			filterCards(strategies["strategies"]);
			contains.querySelector(".filter__block").classList.remove("filter__open");
			contains.querySelector("button").classList.remove("open");
			addToFilterList(values, "country");
		});
	};

	// handle mobile view functionality
	function mobileView(){
		let nextBtn = document.getElementById("js--action"),
			backBtn = document.getElementById("js--mobile-back"),
			top = document.getElementById("finder-anchor__mobile"),
			interactive = document.getElementById("finder--container-for-mobile"),
			filterBlock = document.querySelector(".results--filters"),
			filterMenuBtn = document.getElementById("filter__mobile-expand"),
			filterTotalBtn = document.getElementById("filter__mobile-totals"),
			clearBtn = document.querySelector("#js--mobile-master-controls .filter__clear"),
			submitBtn = document.querySelector("#js--mobile-master-controls .filter__send");

		// move ahead from goal selection screen
		nextBtn.addEventListener("click", () => {
			interactive.style.transform = `translateX(-${window.innerWidth - 15}px)`;
			interactive.style.overflowY = "auto";
			top.scrollIntoView();

			if (!document.getElementById("finder--results").classList.contains("mobile__active-view")) {
				document.getElementById("finder--results").classList.add("mobile__active-view");
			}
		});

		// go back to goal selection screen
		backBtn.addEventListener("click", () => {
			document.getElementById("finder--results").classList.remove("mobile__active-view");
			top.scrollIntoView();
			interactive.style = "";
		});

		// open the filter block and update subfilters
		filterMenuBtn.addEventListener("click", btn => {
			if (filterBlock.classList.contains("mobile-menu-open")) {
				if (checkAllSubfilters()) {
					getFilterTotals();
					filterCards(strategies["strategies"]);
				}

				filterBlock.classList.remove("mobile-menu-open");
				filterMenuBtn.classList.remove("open");
			} else {
				filterMenuBtn.classList.add("open");
				filterBlock.classList.add("mobile-menu-open");
			}
		});

		// clear button event listener
		clearBtn.addEventListener("click", () => {
			if (clearBtn.classList.contains("activated")) {
				clearAllFilters();
				clearBtn.classList.remove("activated");

				getFilterTotals();
				filterCards(strategies["strategies"]);
			}
		});

		// update totals and add button functionality to clear
		filterTotalBtn.addEventListener("click", () => {
			clearAllFilters();
			clearBtn.classList.contains("activated") ? clearGoalsBtn.classList.remove("activated") : "";
			filterTotalBtn.classList.remove("filter__selected");
			filterCards(strategies["strategies"]);
		})

		// clear all active filters and remove clear button access
		function clearAllFilters(){
			let filterSelection = document.querySelectorAll(".selected, input:checked"),
				filterPill = document.querySelectorAll("#results--active-filters .filter--pill");

			filterSelection.forEach(x => {
				x.classList.contains("selected") ? x.classList.remove("selected") : "";
				x.checked == true ? x.checked = false : "";

				activeFilters["country"] = [];
				activeFilters["student-age"] = [];
				activeFilters["lever"] = [];
				activeFilters["tech-level"] = null;
			});

			if(filterPill.length > 0) { filterPill.forEach(pill => { pill.remove() }); };
		};

		// get total number of filters and update flag
		function getFilterTotals(){
			let totalNum = document.getElementById("js--num-selected"),
				total = 0;

			for(let key in activeFilters) {
				if (activeFilters[key] !== null) {
					if (key == "tech-level") {
						if (activeFilters[key]) {
							total = total + 1;
						}
					} else if (key == "goals") {
						total = total;
					} else {
						total = activeFilters[key]?.length + total;
					}
				}
			}

			if (total > 0) {
				totalNum.innerText = total;
				filterTotalBtn.classList.add("filter__selected");
			} else {
				filterTotalBtn.classList.contains("filter__selected") ? filterTotalBtn.classList.remove("filter__selected") : "";
			}
		}

		submitBtn.addEventListener("click", () => {
			if (checkAllSubfilters()) {
				getFilterTotals();
				filterCards(strategies["strategies"]);
			}
			filterBlock.classList.remove("mobile-menu-open");
			filterMenuBtn.classList.remove("open");
		});

		window.addEventListener("resize", () => {
			if (mobile()){
				getFilterTotals();
			} else {
				interactive.style = "";
			}
		})
	}


	// initialize interactive
	buildCards(strategies["strategies"]);
	ageFilter();
	techFilter();
	leverFilter();
	buildCountryDropdown();
	mobileView();
}

document.addEventListener('readystatechange', function() {
	document.readyState === 'interactive' && app(data);
}, false);
// app(data);
stickyHeader();
